/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />

/**
 * NetworkElement service
 */
namespace Application.Services {
    'use strict';

    import HalConverter = Models.HalConverter;
    import IHalList = Models.IHalList;
    import INetworkElement = Models.INetworkElement;
    import NetworkElement = Models.NetworkElement;
    
    /**
     * NetworkElementService
     */
    export class NetworkElementService {
        public static $name: string = "networkElementService";
        public static $inject: string[] = ['backendService'];

        private backendService: BackendService;
        private backendBaseUrl: string = window.backendUrl;
        // private servicePath: string = 'networkElement/';
        private servicePath: string = '';
        private backendUrl: string = this.backendBaseUrl + this.servicePath + 'networkElements';
        
        constructor(backendService: BackendService) {
            this.backendService = backendService;
        }

        public getMappingFromNodeToNode(request: Models.MappingInfoRequest): ng.IPromise<Models.MappingInfo> {
            return this.backendService.post(this.backendUrl + "/mapping", request, false, undefined, false)
            .then((result: ng.IHttpPromiseCallbackArg<Models.MappingInfo>) => {
                return result.data;
            }).catch((reason: ng.IHttpPromiseCallbackArg<Models.MappingInfo>) => {
                return undefined;
            });
        }

        public findConnectedToNetworkId(networkId: number): ng.IPromise<INetworkElement[]> {
            return this.backendService.get(this.backendUrl + "/findConnectedToNetworkId/" + networkId)
            .then((result: ng.IHttpPromiseCallbackArg<Models.IHalList<INetworkElement>>) => {
                let halElement: IHalList<INetworkElement> = result.data;
                let converted: INetworkElement[] = HalConverter.convertList(halElement, NetworkElement.Empty);
                return converted;
            });
        }

        /*
        public setDefaultGateway(networkElementId: number, gatewayId: number): ng.IPromise<Models.IProbe> {            
            return this.backendService.put(this.backendUrl + "/" + networkElementId + "/defaultGateway/" + gatewayId, {});
        }

        public removeDefaultGateway(networkElementId: number): ng.IPromise<boolean> {
            return this.backendService.delete(this.backendUrl + "/" + networkElementId + "/defaultGateway");
        }
        */
    }
}